import { jsx as d } from "react/jsx-runtime";
import { c, a as p, b as u } from "./utils-B9z9WPG8.js";
const f = u(["relative", "overflow-hidden", "rounded-(--radius-sm)", "border", "border-outline-subtle", "bg-surface", "text-text-default", "shadow-elevation-1"], {
  variants: {
    padding: {
      none: "p-0",
      sm: "p-(--spacing-16)",
      md: "p-(--spacing-20)",
      lg: "p-(--spacing-24)"
    },
    tone: {
      default: "",
      muted: "bg-surface-container-low",
      elevated: "border-outline-variant shadow-elevation-2"
    }
  },
  defaultVariants: {
    padding: "md",
    tone: "default"
  }
});
function v(l) {
  const e = c.c(14);
  let t, a, n, o, r;
  e[0] !== l ? ({
    padding: n,
    tone: r,
    className: a,
    children: t,
    ...o
  } = l, e[0] = l, e[1] = t, e[2] = a, e[3] = n, e[4] = o, e[5] = r) : (t = e[1], a = e[2], n = e[3], o = e[4], r = e[5]);
  let s;
  e[6] !== a || e[7] !== n || e[8] !== r ? (s = p(f({
    padding: n,
    tone: r
  }), a), e[6] = a, e[7] = n, e[8] = r, e[9] = s) : s = e[9];
  let i;
  return e[10] !== t || e[11] !== o || e[12] !== s ? (i = /* @__PURE__ */ d("section", { className: s, ...o, children: t }), e[10] = t, e[11] = o, e[12] = s, e[13] = i) : i = e[13], i;
}
export {
  v as Card
};
//# sourceMappingURL=experimental.js.map
